// src/pages/RegisterTicket.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, updateDoc, collection, getDocs } from 'firebase/firestore';
import QRScannerComponent from '../components/QRScannerComponent';
import jsQR from 'jsqr';
import Confetti from 'react-confetti';
import { useNavigate } from 'react-router-dom';

const RegisterTicket = () => {
  const [shirtInventory, setShirtInventory] = useState({});
  const [hideShirtSize, setHideShirtSize] = useState(false);
  const [scannedId, setScannedId] = useState('');
  const [ticketFound, setTicketFound] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [isSpecialTag, setIsSpecialTag] = useState(false);
  const [specialTag, setSpecialTag] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    age: '',
    gender: '',
    civilStatus: '',
    contactNumber: '',
    emailAddress: '',
    presentAddress: '',
    profession: '',
    firstTimeCCF: '',
    firstTimeTrueLife: '',
    dgroupLeader: '',
    inDgroup: '',
    invitedBy: '',
    tshirtSize: '',
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [savedData, setSavedData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "shirtInventory"));
        const inventory = {};
        querySnapshot.forEach((doc) => {
          inventory[doc.id.toUpperCase()] = doc.data().available;
        });
        setShirtInventory(inventory);
      } catch (error) {
        console.error("❌ Error fetching shirt inventory:", error);
      }
    };
    fetchInventory();
  }, []);

  const handleScanSuccess = async (data) => {
    console.log('✅ QR Detected:', data);

    if (!/^[a-zA-Z0-9]{20,22}$/.test(data)) {
      alert('❌ Invalid QR Code! Please scan an official True Life Retreat ticket!');
      return;
    }

    setScannedId(data);

    try {
      const tagDoc = await getDoc(doc(db, "ticketTags", data));
      if (tagDoc.exists()) {
        const tagData = tagDoc.data();
        if (tagData.tag === 'Facilitator' || tagData.tag === 'NoShirt') {
          setIsSpecialTag(true);
          setSpecialTag(tagData.tag);
          setHideShirtSize(true);
        } else {
          setIsSpecialTag(false);
          setSpecialTag('');
          setHideShirtSize(false);
        }
      } else {
        setIsSpecialTag(false);
        setSpecialTag('');
        setHideShirtSize(false);
      }

      const ticketDoc = await getDoc(doc(db, "tickets", data));
      if (ticketDoc.exists()) {
        if (ticketDoc.data().registeredAt) {
          alert('❌ This ticket is already registered.');
          setTicketFound(false);
          return;
        }
        setTicketFound(true);
      } else {
        await setDoc(doc(db, "tickets", data), {
          ticketId: data,
          createdAt: new Date()
        });
        setTicketFound(true);
      }
    } catch (error) {
      console.error('❌ Error checking ticket:', error);
      setTicketFound(false);
    }
  };

  const handleScanError = (error) => {
    console.error('❌ Scan Error:', error);
  };

  const handleAgree = () => {
    setAgreed(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const ticketRef = doc(db, "tickets", scannedId);
      const ticketSnap = await getDoc(ticketRef);

      if (ticketSnap.exists() && ticketSnap.data().registeredAt) {
        alert('❌ This ticket is already registered.');
        return;
      }

      if (!hideShirtSize) {
        const size = formData.tshirtSize;
        const sizeRef = doc(db, "shirtInventory", size);
        const sizeSnap = await getDoc(sizeRef);

        if (sizeSnap.exists()) {
          const available = sizeSnap.data().available || 0;
          if (available <= 0) {
            alert(`❌ No shirts available for size ${size}.`);
            return;
          }
          await updateDoc(sizeRef, { available: available - 1 });
        } else {
          alert('❌ Shirt inventory not found.');
          return;
        }
      }

      await updateDoc(ticketRef, {
        ...formData,
        registeredAt: new Date(),
      });

      alert('✅ Registration Successful!');
      setSavedData(formData);
      setShowSuccess(true);

    } catch (error) {
      console.error('Error saving registration:', error);
      alert('❌ Failed to register ticket. Please try again.');
    }
  };

  const handleUploadQR = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code) {
          handleScanSuccess(code.data);
        } else {
          alert('❌ No QR code detected. Try again.');
        }
      };
    };
    reader.readAsDataURL(file);
  };

  if (showSuccess) {
    return (
      <div style={{
        backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/truelifeticketing.firebasestorage.app/o/App%20Asset%2FConratualtions%20Reg.jpg?alt=media&token=454bdb4a-e4b5-40f8-b3a0-012d5356296f')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        color: '#000000',
        minHeight: '100vh',
        padding: '50px 20px',
        textAlign: 'center'
      }}>
        <Confetti width={window.innerWidth} height={window.innerHeight} />
        <div style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
          maxWidth: '600px',
          margin: 'auto'
        }}>
          <h1 style={{ color: '#28a745', marginBottom: '20px' }}>🎉 Registration Complete!</h1>
          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${scannedId}`} alt="QR Code" style={{ marginBottom: '20px' }} />
          <table style={{ margin: '0 auto', fontSize: '16px', width: '100%', textAlign: 'left' }}>
            <tbody>
              <tr><td><b>Ticket ID:</b></td><td>{scannedId}</td></tr>
              <tr><td><b>Name:</b></td><td>{savedData.firstName} {savedData.lastName}</td></tr>
              <tr><td><b>Age:</b></td><td>{savedData.age}</td></tr>
              <tr><td><b>Gender:</b></td><td>{savedData.gender}</td></tr>
              <tr><td><b>Civil Status:</b></td><td>{savedData.civilStatus}</td></tr>
              <tr><td><b>Contact:</b></td><td>{savedData.contactNumber}</td></tr>
              <tr><td><b>Email:</b></td><td>{savedData.emailAddress}</td></tr>
              <tr><td><b>Address:</b></td><td>{savedData.presentAddress}</td></tr>
              {!hideShirtSize && (
                <tr><td><b>T-Shirt Size:</b></td><td>{savedData.tshirtSize}</td></tr>
              )}
            </tbody>
         </table>
          <button
            onClick={() => navigate('/')}
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "rgba(255, 255, 255, 0.8)", /* ✅ changed */
              boxShadow: "0 0 10px rgba(0,0,0,0.1)"
             }}
            >
            🔙 Back to Homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/truelifeticketing.firebasestorage.app/o/App%20Asset%2FRegisterTickets.jpg?alt=media&token=caf72a26-dd8e-4305-8545-58e11ffe3eff')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      padding: '20px',
      color: 'white' 
      }}>

      <h1 style={{ textAlign: 'center' }}>Register Your Ticket</h1>

      {!ticketFound && (
        <div style={{ textAlign: "center" }}>
          <QRScannerComponent onScanSuccess={handleScanSuccess} onScanError={handleScanError} />
          <p style={{ marginTop: "20px" }}>Scan your ticket QR Code or Upload QR Image:</p>
          <input type="file" accept="image/*" onChange={handleUploadQR} />
        </div>
      )}


      {ticketFound && !agreed && (
        <div style={{ textAlign: 'center', marginTop: '30px', backgroundColor: '#f5f5f5', color: '#000', padding: '20px', borderRadius: '10px' }}>
          <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px' }}>
            Data Privacy Notice
          </p>
          <p style={{ fontSize: '16px', lineHeight: '1.5' }}>
            In compliance with <strong>Republic Act No. 10173, the Philippine Data Privacy Act of 2012</strong>, we are committed to protecting your personal information.
          </p>
          <p style={{ fontSize: '16px', lineHeight: '1.5', marginTop: '15px' }}>
            By registering, you agree and consent that the information you provide will be collected, processed, and used solely for the purpose of organizing and managing the <strong>True Life Retreat 2025</strong>.
          </p>
          <p style={{ fontSize: '16px', lineHeight: '1.5', marginTop: '15px' }}>
            By clicking "I Agree", you signify your consent to the collection and use of your personal information as described above.
          </p>
          <button onClick={handleAgree} style={buttonStyle}>I Agree</button>
       </div>
     )}


      {ticketFound && agreed && (
        <form onSubmit={handleSubmit} style={{ maxWidth: '600px', margin: '30px auto' }}>
          {isSpecialTag && (
            <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>
              🚩 Ticket is tagged as: <strong>{specialTag}</strong>
            </div>
          )}
          <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required style={inputStyle} />
          <input type="text" name="middleName" placeholder="Middle Name (optional)" value={formData.middleName} onChange={handleChange} style={inputStyle} />
          <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required style={inputStyle} />
          <input type="number" name="age" placeholder="Age" value={formData.age} onChange={handleChange} required style={inputStyle} />

          <select name="gender" value={formData.gender} onChange={handleChange} required style={inputStyle}>
            <option value="">Select Gender</option>
            <option>Male</option>
            <option>Female</option>
          </select>

          <select name="civilStatus" value={formData.civilStatus} onChange={handleChange} required style={inputStyle}>
            <option value="">Select Civil Status</option>
            <option>Single</option>
            <option>Married</option>
            <option>Widowed</option>
          </select>

          <input type="text" name="contactNumber" placeholder="Contact Number" value={formData.contactNumber} onChange={handleChange} required style={inputStyle} />
          <input type="email" name="emailAddress" placeholder="Email Address" value={formData.emailAddress} onChange={handleChange} required style={inputStyle} />
          <input type="text" name="presentAddress" placeholder="Present Location" value={formData.presentAddress} onChange={handleChange} required style={inputStyle} />
          <input type="text" name="profession" placeholder="Profession" value={formData.profession} onChange={handleChange} style={inputStyle} />

      {/* First time attending CCF Events */}
          <select name="firstTimeCCF" value={formData.firstTimeCCF} onChange={handleChange} required style={inputStyle}>
            <option value="">Is this your first time attending CCF Events?</option>
            <option>Yes</option>
            <option>No</option>
          </select>

      {/* First time attending True Life Retreat */}
          <select name="firstTimeTrueLife" value={formData.firstTimeTrueLife} onChange={handleChange} required style={inputStyle}>
            <option value="">Is attending True Life Retreat a first time?</option>
            <option>Yes</option>
            <option>No</option>
          </select>

      {/* Dgroup Leader */}
          <select name="dgroupLeader" value={formData.dgroupLeader} onChange={handleChange} required style={inputStyle}>
            <option value="">Are you a CCF Dgroup Leader?</option>
            <option>Yes</option>
            <option>No</option>
          </select>

     {/* In Dgroup */}
         <select name="inDgroup" value={formData.inDgroup} onChange={handleChange} required style={inputStyle}>
           <option value="">Are you part of a CCF Dgroup?</option>
           <option>Yes</option>
           <option>No</option>
         </select>

     {/* If No, Ask to Join Dgroup */}
     {formData.inDgroup === 'No' && (
         <select name="wantsToJoinDGroup" value={formData.wantsToJoinDGroup} onChange={handleChange} required style={inputStyle}>
           <option value="">Would you like to join a Dgroup?</option>
           <option>Yes</option>
           <option>No</option>
         </select>
     )}

     {/* Invited By */}
         <input type="text" name="invitedBy" placeholder="Who invited you?" value={formData.invitedBy} onChange={handleChange} style={inputStyle} />

          {!hideShirtSize && (
            <select name="tshirtSize" value={formData.tshirtSize} onChange={handleChange} required style={inputStyle}>
              <option value="">Select Shirt Size</option>
              {Object.entries(shirtInventory).map(([size, available]) => (
                available > 0 && (
                  <option key={size} value={size}>
                    {size} ({available} left)
                  </option>
                )
              ))}
            </select>
          )}
          <button type="submit" style={buttonStyle}>✅ Submit Registration</button>
        </form>
      )}
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  margin: '10px 0',
  borderRadius: '5px',
  fontSize: '16px',
};

const buttonStyle = {
  marginTop: '20px',
  padding: '10px 20px',
  fontSize: '18px',
  borderRadius: '8px',
  backgroundColor: '#28a745',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
};

export default RegisterTicket;
